import { RegisteredIcon } from '@/lib/icons';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

export interface NavigationItem {
  id: string;
  href: string;
  icon: RegisteredIcon;
  label: string;
}

const getCurrentSectionFromPath = (
  pathname: string,
  navigationItems: NavigationItem[]
): SelectionState | null => {
  const item = navigationItems.find(({ href }) => pathname.startsWith(href));

  if (item) {
    return {
      href: item.href,
      isRoot: pathname === item.href,
    };
  }
  return null;
};

interface SelectionState {
  href: string;
  isRoot: boolean;
}

interface UseSectionNavigationOptions {
  navigationItems: NavigationItem[];
}

const useSectionNavigation = ({
  navigationItems,
}: UseSectionNavigationOptions) => {
  const { pathname } = useRouter();

  const [selectedItem, setSelectedItem] = useState<SelectionState | null>(
    getCurrentSectionFromPath(pathname, navigationItems)
  );

  useEffect(() => {
    setSelectedItem(getCurrentSectionFromPath(pathname, navigationItems));
  }, [pathname, navigationItems]);

  return {
    selectedItem,
  };
};

export default useSectionNavigation;
